import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy } from "@angular/core";
import { SharingDataService } from "src/app/services/sharing-data.service";
import { GfxGedService } from "../gfx-ged/gfx.ged.service";
import { ConfigGedFile } from "../gfx-ged/config-ged-file";

@Component({
  selector: "file-input",
  templateUrl: "./file-input.component.html",
  styleUrls: ["./file-input.component.css"]
})
export class FileInputComponent implements OnInit {
  public state: any = {};

  @Input() multiple: boolean;
  @ViewChild("input") input: ElementRef;
  fileToUpload: any;

  constructor(private sharing: SharingDataService, private gedService: GfxGedService) {

  }

  ngOnInit() {
    this.sharing.initDataGedFile();
    this.sharing.currentDataGedFile.subscribe((dataGedFile: ConfigGedFile[]) => { 
      if (dataGedFile && dataGedFile.length && this.fileToUpload)
        this.gedService.newFile(this.fileToUpload, dataGedFile);
    })
  }
  onFocus(e) {
    this.input.nativeElement.click(e);
  }
  handleSubmit(e) {
    e.preventDefault();
    // this.state.file is the file/image uploaded
    // in this function you can save the image (this.state.file) on form submit
    // you have to call it yourself
  }
  addFile() {
    this.fileToUpload = this.input.nativeElement.files[0]; 
    let fileNames = "";
    let files = this.input.nativeElement.files;
    for (let i = 0; i < files.length; i++) {
      fileNames = fileNames + files[i].name;
      if (i !== files.length - 1) {
        fileNames = fileNames + ", ";
      }
    }
    this.state.fileNames = fileNames;
    this.state.files = files;
  }

  
}
